import { render, staticRenderFns } from "./ExpiredLinkResetView.vue?vue&type=template&id=7f053d46"
import script from "./ExpiredLinkResetView.vue?vue&type=script&lang=js"
export * from "./ExpiredLinkResetView.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLinkResetView.vue?vue&type=style&index=0&id=7f053d46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports